import { HttpClient, HttpBackend } from '@angular/common/http';
import { ApiAuthInterceptor } from 'app/http/interceptors/api-auth.interceptor';
import { ApiUrlInterceptor } from 'app/http/interceptors/api-url.interceptor';
import { ApiHttpHandler } from 'app/http/handler';
import { Injectable } from '@angular/core';
import { ApiResponseInterceptor } from 'app/http/interceptors/api-response.interceptor';
import { environment } from 'environments/environment';
import { Location } from '@angular/common';

@Injectable()
export class BpApiHttpClient extends HttpClient {
    constructor(backend: HttpBackend, location: Location) {
        super(new ApiHttpHandler(backend, [
            new ApiAuthInterceptor(),
            new ApiUrlInterceptor(environment.BP_API_URL),
            new ApiResponseInterceptor(location)
        ]));
    }
}
